import { ModuleFE_Book } from './ModuleFE_Book.js';
export const ModulePackFE_BookDB = [ModuleFE_Book];
//# sourceMappingURL=module-pack.js.map